const dualList = {
  pickedAmount: '{{picked}} of {{total}} items selected',
};

export default dualList;
